/**
 * Helper function to select menu based on transfer station mode
 * Reduces repetitive ternary operators throughout the component
 */
export const selectMenu = <T,>(
    isTransferStation: boolean,
    transferStationMenu: T,
    regularMenu: T
): T => {
    return isTransferStation ? transferStationMenu : regularMenu;
};
